import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Landing        from './pages/Landing';
import Login         from './pages/Login';
import Signup        from './pages/Signup';
import Setup         from './pages/Setup';
import Dashboard     from './pages/Dashboard';
import Clients       from './pages/Clients';
import Invoices      from './pages/Invoices';
import InvoiceCreate from './pages/InvoiceCreate';
import InvoiceDetail from './pages/InvoiceDetail';
import Files            from './pages/Files';
import Contracts       from './pages/Contracts';
import ContractCreate  from './pages/ContractCreate';
import ContractDetail  from './pages/ContractDetail';
import Settings        from './pages/Settings';
import ClientPortal    from './pages/ClientPortal';
import PaymentSuccess  from './pages/PaymentSuccess';
import PaymentCancel   from './pages/PaymentCancel';

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (!user.user_metadata?.setup_complete) return <Navigate to="/setup" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  return !user ? children : <Navigate to="/dashboard" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />

      {/* Auth */}
      <Route path="/login"  element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/signup" element={<PublicRoute><Signup /></PublicRoute>} />
      <Route path="/setup"  element={<Setup />} />

      {/* App */}
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/clients"   element={<ProtectedRoute><Clients /></ProtectedRoute>} />

      {/* Invoices — order matters: /new before /:id */}
      <Route path="/invoices"          element={<ProtectedRoute><Invoices /></ProtectedRoute>} />
      <Route path="/invoices/new"      element={<ProtectedRoute><InvoiceCreate /></ProtectedRoute>} />
      <Route path="/invoices/:id"      element={<ProtectedRoute><InvoiceDetail /></ProtectedRoute>} />
      <Route path="/invoices/:id/edit" element={<ProtectedRoute><InvoiceCreate /></ProtectedRoute>} />
      <Route path="/files"             element={<ProtectedRoute><Files /></ProtectedRoute>} />
      <Route path="/settings"          element={<ProtectedRoute><Settings /></ProtectedRoute>} />

      {/* Contracts — order matters: /new before /:id */}
      <Route path="/contracts"          element={<ProtectedRoute><Contracts /></ProtectedRoute>} />
      <Route path="/contracts/new"      element={<ProtectedRoute><ContractCreate /></ProtectedRoute>} />
      <Route path="/contracts/:id"      element={<ProtectedRoute><ContractDetail /></ProtectedRoute>} />
      <Route path="/contracts/:id/edit" element={<ProtectedRoute><ContractCreate /></ProtectedRoute>} />

      {/* Public routes — no auth required */}
      <Route path="/portal/:token"   element={<ClientPortal />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-cancel"  element={<PaymentCancel />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            style: { borderRadius: '12px', fontSize: '14px' },
            success: { iconTheme: { primary: '#4f46e5', secondary: '#fff' } },
          }}
        />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
